import {
  SHOP_FIND_OR_CREATE_REQUESTED,
  SHOP_FIND_OR_CREATE_SUCCESS,
  SHOP_FIND_OR_CREATE_FAILURE,
  SHOP_SETTINGS_FIND_REQUESTED,
  SHOP_SETTINGS_FIND_SUCCESS,
  SHOP_SETTINGS_FIND_FAILURE,
  SHOPIFY_SETTINGS_FIND_REQUESTED,
  SHOPIFY_SETTINGS_FIND_SUCCESS,
  SHOPIFY_SETTINGS_FIND_FAILURE,
} from '../types';

const INITIAL_STATE = {
  shop: null,
  activeSubscriptions: [],
  settings: {},
  shopSettings: {},
  isFetching: false,
  status: 'waiting',
  errors: null
};

const shops = (state = INITIAL_STATE, action) => {
  switch(action.type) {
    case SHOP_FIND_OR_CREATE_REQUESTED:
      return Object.assign({}, state, {
        isFetching: true,
        status: 'requesting'
      });

    case SHOP_FIND_OR_CREATE_SUCCESS:
      return Object.assign({}, state, {
        shop: action.payload.shop,
        activeSubscriptions: action.payload.subscriptions,
        isFetching: false,
        status: 'success',
        errors: null
      });

    case SHOP_FIND_OR_CREATE_FAILURE:
      return Object.assign({}, state, {
        isFetching: false,
        status: 'waiting',
        errors: 'error here'
      });

    case SHOP_SETTINGS_FIND_REQUESTED:
      return Object.assign({}, state, {
        isFetching: true,
      });

    case SHOP_SETTINGS_FIND_SUCCESS:
      return Object.assign({}, state, {
        settings: action.payload.shop_information,
        isFetching: false,
        errors: null
      });

    case SHOP_SETTINGS_FIND_FAILURE:
      return Object.assign({}, state, {
        errors: 'error here'
      });


    case SHOPIFY_SETTINGS_FIND_REQUESTED:
      return Object.assign({}, state, {
        errors: null,
      });

    case SHOPIFY_SETTINGS_FIND_SUCCESS:
      return Object.assign({}, state, {
        shopSettings: action.payload.settings
      });

    case SHOPIFY_SETTINGS_FIND_FAILURE:
      return Object.assign({}, state, {
        errors: 'error here'
      });



    default:
      return state;
  }
}

export default shops;
